// client/src/coms/conversations/MobileDmsView.js
// Phones: DMs. Every direct message conversation, newest first, opened with one tap; Friends and friend
// requests sit beside it as sections of the same screen. (On desktop the DM list is the left sidebar.)
import React, { useMemo, useState } from 'react';
import ConversationSections from './ConversationList';
import './conversations.css';

export function DmsSections({ section, onSection, requests = 0 }) {
  const items = [
    { id: 'dms', label: 'Messages' },
    { id: 'friends', label: 'Friends' },
    { id: 'pending', label: requests ? `Requests (${requests})` : 'Requests' },
  ];
  return (
    <div className="vx-dms-seg" role="tablist" aria-label="Direct messages" data-testid="dms-sections">
      {items.map((it) => (
        <button
          key={it.id}
          type="button"
          role="tab"
          aria-selected={section === it.id}
          className={`vx-dms-seg-btn${section === it.id ? ' is-on' : ''}`}
          onClick={() => onSection(it.id)}
          data-testid={`dms-section-${it.id}`}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}

export default function MobileDmsView({ index, onOpen, onPin, pinnedIds, activeId }) {
  const [query, setQuery] = useState('');
  const dms = useMemo(() => index.all.filter((it) => it.kind === 'dm').sort((a, b) => b.at - a.at), [index.all]);
  const shown = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? dms.filter((it) => `${it.title} ${it.preview}`.toLowerCase().includes(q)) : dms;
  }, [dms, query]);
  const unread = shown.filter((it) => it.unread);
  const rest = shown.filter((it) => !it.unread);

  return (
    <div className="coms-view vx-chats vx-dms" data-testid="dms-view">
      {dms.length > 6 ? (
        <div className="vx-chats-head">
          <input
            type="search"
            className="vx-chats-search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Find a conversation"
            aria-label="Find a direct message"
            data-testid="dms-search"
          />
        </div>
      ) : null}
      <div className="vx-chats-body">
        {!dms.length ? (
          <div className="vx-conv-empty-state">
            <div aria-hidden="true">✉️</div>
            <strong>{index.loaded ? 'No direct messages yet' : 'Loading conversations…'}</strong>
            {index.loaded ? <p>Open Friends to message someone, or tap a name in a server to start a conversation.</p> : null}
          </div>
        ) : (
          <ConversationSections
            sections={[
              { key: 'unread', title: 'Unread', items: unread },
              { key: 'all', title: unread.length ? 'Earlier' : 'Conversations', items: rest, empty: query.trim() && !unread.length ? `No conversation matches “${query.trim()}”.` : undefined },
            ]}
            onOpen={onOpen}
            onPin={onPin}
            pinnedIds={pinnedIds}
            activeId={activeId}
          />
        )}
      </div>
    </div>
  );
}
